import { useTranslation } from 'react-i18next';
import { Page } from '@web/components/page';
import { BuyingAPetScreen, BuyingAPetScreenProps } from 'shared/screens/buying-a-pet';
import { withServerProps } from '@web/library/with-server-props';

export default function BuyingAPet(props: BuyingAPetScreenProps) {
  const { t } = useTranslation('screens');

  return (
    <Page
      {...props}
      register={(seo) => seo.forPage(t('buying_a_pet.title'), t('buying_a_pet.description'))}
    >
      <BuyingAPetScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps(BuyingAPetScreen.pageBuilder);
